import type { FeedbackMessages } from './en';

const cs: FeedbackMessages = {
  qualified: {
    title: 'Děkujeme, že jste dokončili tento průzkum!',
    body1: 'Nyní můžete zavřít okno prohlížeče.',
    body2: 'Doufáme, že se s Vámi brzy setkáme znovu.',
    refCode: 'Referenční kód: {code}',
  },
  quotaFull: {
    title: 'Tento průzkum je uzavřen',
    body1: 'Děkujeme za Váš zájem o náš průzkum.',
    body2: 'Bohužel jsme již obdrželi všechny odpovědi, které jsme potřebovali.',
    body3: 'Doufáme, že se s Vámi setkáme v některém z našich budoucích průzkumů!',
    refCode: 'Referenční kód: {code}',
  },
  terminated: {
    title: 'Děkujeme za Vaši zpětnou vazbu!',
    body1:
      'Doufáme, že se s Vámi brzy setkáme v některém z našich budoucích průzkumů. Do té doby Vám přejeme krásný den.',
    body2: 'Zavřete prosím toto okno prohlížeče.',
    refCode: 'Referenční kód: {code}',
  },
  mismatch: {
    title: 'Děkujeme za Váš zájem',
    body1: 'Bohužel nespadáte do cílové skupiny pro tento konkrétní průzkum.',
    body2: 'Tuto stránku můžete zavřít.',
    code: 'Kód: {code}',
  },
  error: {
    title: 'Vaši žádost nelze zpracovat',
    linkProblemDetailed:
      'S odkazem, na který jste klikli, se vyskytl problém. Zkontrolujte prosím, zda odkaz v adresním řádku odpovídá tomu, který Vám byl zaslán, a zkuste to znovu.',
    linkProblemGeneric:
      'S odkazem, na který jste klikli, se vyskytl problém. Zkuste to prosím znovu.',
    contactPerson:
      'Pokud problém přetrvává, informujte o něm prosím osobu, od které jste odkaz obdrželi.',
    errorCode: 'Chybový kód: {code}',
  },
};

export default cs;
